// extracted by mini-css-extract-plugin
export const post__footer = "Post-module--post__footer--L98TP";
export const post__comments = "Post-module--post__comments--21hyQ";
export const post__homeButton = "Post-module--post__home-button--33KJx";